import { Navigate, Outlet } from "react-router-dom";

const AuthGuard = ({ redirectPath = "/" }) => {
  const isAuthenticated = !!localStorage.getItem("auth_token");

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
